// Stat Counter JS + animate once in viewport

// How long you want the animation to take, in ms
const animationDuration = 2000;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
const frameDuration = 1000 / 60;
// Use that to calculate how many frames we need to complete the animation
const totalFrames = Math.round(animationDuration / frameDuration);
// An ease-out function that slows the count as it progresses
const easeOutQuad = (t) => t * (2 - t);


var addDataAttr = document.querySelectorAll(".acf-counter .number");
	addDataAttr.forEach(function (newAttribute) {
		newAttribute.dataset.countUp = newAttribute.textContent;
	});

// The animation function, which takes an Element
const animateCountUp = (el) => {
	let frame = 0;
	const countTo = el.textContent;
	let countPrecision = 0;
	if (countTo.includes(".")) {
		let startHere = countTo.split(".");
		countPrecision = startHere[1].length;
	}

	// Start the animation running 60 times per second
	const counter = setInterval(() => {
		frame++;
		// Calculate our progress as a value between 0 and 1
		// Pass that value to our easing function to get our
		// progress on a curve
		const progress = easeOutQuad(frame / totalFrames);
		// Use the progress value to calculate the current count

		let currentCount;

		if (countPrecision) {
			currentCount = (countTo * progress).toFixed(countPrecision);
			// return currentCount;
		} else {
			currentCount = Math.round(countTo * progress);
			// return currentCount;
		}

		// If the current count has changed, update the element
		if (parseFloat(el.textContent) !== currentCount) {
			el.textContent = currentCount;
		}

		// If we’ve reached our last frame, stop the animation
		if (frame === totalFrames) {
			el.textContent = el.dataset.countUp;
			clearInterval(counter);
		}
	}, frameDuration);
};

if ("IntersectionObserver" in window || !!window.IntersectionObserver) {
	const observerThreshold = 0;

	// Set up observer
	var countUpObserver = new IntersectionObserver(
		function (entries, observer) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					animateCountUp(entry.target);
				}
			});
		},
		{ threshold: observerThreshold },
	);

	// Activate observer
	var elements = document.querySelectorAll(".acf-counter .number");
	elements.forEach(function (element) {
		countUpObserver.observe(element);
	});
}
